var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-block",class:{ selected: _vm.selected },style:(_vm.wrapperStyle)},[_c('hr',{style:(_vm.hrStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }